/* eslint-disable @next/next/inline-script-id */
import Script from "next/script"
import { getWindow } from "utils-lib/getWindow"

const window = getWindow()

const ThirdPartyScripts = () => (
  <>
    <Script
      type="text/javascript"
      dangerouslySetInnerHTML={{
        __html: `window._dl = window._dl || {}`,
      }}
    />
    {/* prevent loading launch in dev mode to prevent annoying error messages */}
    {process.env.NEXT_PUBLIC_NODE_ENV !== "prod" && (
      <Script src="https://assets.adobedtm.com/3010f46ab2ec/a3cbfcd83a52/launch-01b1cb6f5edd-development.min.js" />
    )}
    {process.env.NEXT_PUBLIC_NODE_ENV === "prod" && (
      <Script src="https://assets.adobedtm.com/3010f46ab2ec/a3cbfcd83a52/launch-4688d17a7429.min.js" />
    )}
    {!process.env.NEXT_PUBLIC_NODE_ENV === "prod" && (
      <Script
        type="text/javascript"
        src="https://cdn.cookielaw.org/consent/3c68903b-ecb7-42b9-b874-6e1bf32a27e5/OtAutoBlock.js"
      />
    )}
    {!process.env.NEXT_PUBLIC_NODE_ENV !== "prod" && (
      <Script
        type="text/javascript"
        src="https://cdn.cookielaw.org/consent/3c68903b-ecb7-42b9-b874-6e1bf32a27e5-test/OtAutoBlock.js"
      />
    )}
    <Script
      src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
      type="text/javascript"
      charset="UTF-8"
      // TODO: look into updating this to work for /
      // we can use acceptLanguage header to determine language
      data-language={window.location.pathname === "/ca/fr" ? "fr" : "en"}
      // TODO: Check for onLoad way of calling
      data-domain-script={process.env.NEXT_PUBLIC_ONETRUST_KEY}
    />
    <Script
      type="text/javascript"
      dangerouslySetInnerHTML={{
        __html: `
          function OptanonWrapper() {
            if (OnetrustActiveGroups && OnetrustActiveGroups.includes("C0009")) {
              const event = new Event("logrocketload");
              document.dispatchEvent(event);
            }
          }
        `,
      }}
    />
  </>
)

export default ThirdPartyScripts
